(() => {
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('is-shopify-theme-editor');
  }

  const openCart = () => {
    const cartTrigger = document.querySelector('[data-side-cart-trigger]');

    if (cartTrigger) {
      cartTrigger.click();
      return;
    }

    window.location.assign('/cart');
  };

  const getProductControl = (selector) => document.querySelector(`.product-main ${selector}`);

  const addCurrentProductToCart = async () => {
    const atcControl = getProductControl('[data-product-atc]');
    const productForm = (atcControl && atcControl.closest('form')) || document.querySelector('form[data-product-form]');

    if (!productForm) {
      if (atcControl) atcControl.click();
      return;
    }

    const formData = new FormData(productForm);
    const variantId = formData.get('id');

    if (!variantId || variantId === 'not-selected') {
      if (atcControl) atcControl.click();
      return;
    }

    const requestedQuantity = fixedQuantityInput
      ? Math.max(1, Number.parseInt(fixedQuantityInput.value, 10) || 1)
      : Math.max(1, Number.parseInt(formData.get('quantity'), 10) || 1);
    const cartAddUrl = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
    const cartUrl = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart').replace(/\.js$/, '') + '.js';

    formData.set('quantity', String(requestedQuantity));

    const addResponse = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });

    if (!addResponse.ok) {
      throw new Error('Unable to add product to cart');
    }

    const cartResponse = await fetch(cartUrl, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!cartResponse.ok) {
      openCart();
      return;
    }

    window.dispatchEvent(new CustomEvent('cartcount:update', {
      detail: await cartResponse.json()
    }));
  };

  const fixedQuantityInput = document.querySelector('[data-fixed-quantity-input]');
  const fixedQuantityMinus = document.querySelector('[data-fixed-quantity-minus]');
  const fixedQuantityPlus = document.querySelector('[data-fixed-quantity-plus]');
  const productQuantityInput = getProductControl('quantity-selector [data-quantity-input]');

  if (fixedQuantityInput && productQuantityInput) {
    const getMinimum = () => Number.parseInt(productQuantityInput.min, 10) || 1;
    const getMaximum = () => Number.parseInt(productQuantityInput.max, 10) || Number.POSITIVE_INFINITY;
    const getStep = () => Number.parseInt(productQuantityInput.dataset.incrementValue || productQuantityInput.step, 10) || 1;

    const normalizeQuantity = (value) => {
      const parsed = Number.parseInt(value, 10);
      const fallback = Number.parseInt(productQuantityInput.value, 10) || getMinimum();
      return Math.min(getMaximum(), Math.max(getMinimum(), Number.isFinite(parsed) ? parsed : fallback));
    };

    const updateFixedInput = () => {
      fixedQuantityInput.value = normalizeQuantity(productQuantityInput.value);
    };

    const updateProductInput = (value) => {
      const quantity = normalizeQuantity(value);
      productQuantityInput.value = quantity;
      fixedQuantityInput.value = quantity;
      productQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      productQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    updateFixedInput();
    productQuantityInput.addEventListener('input', updateFixedInput);
    productQuantityInput.addEventListener('change', updateFixedInput);

    fixedQuantityMinus.addEventListener('click', () => {
      updateProductInput(normalizeQuantity(productQuantityInput.value) - getStep());
    });

    fixedQuantityPlus.addEventListener('click', () => {
      updateProductInput(normalizeQuantity(productQuantityInput.value) + getStep());
    });

    fixedQuantityInput.addEventListener('input', () => {
      updateProductInput(fixedQuantityInput.value);
    });

    fixedQuantityInput.addEventListener('change', () => {
      updateProductInput(fixedQuantityInput.value);
    });
  }

  const mobilePrimaryImage = document.querySelector('[data-mobile-primary-image]');

  if (mobilePrimaryImage) {
    const primaryThumbnail = document.querySelector('.product-mobile-image-preview__thumbnail:first-child');

    const setMobilePrimaryImage = (src, alt, syncVariantThumbnail = false) => {
      if (!src) return;

      const imageUrl = src.startsWith('//') ? `https:${src}` : src;
      mobilePrimaryImage.src = imageUrl;
      mobilePrimaryImage.alt = alt || mobilePrimaryImage.alt;
      mobilePrimaryImage.removeAttribute('srcset');
      mobilePrimaryImage.removeAttribute('sizes');

      if (syncVariantThumbnail && primaryThumbnail) {
        primaryThumbnail.dataset.mobileProductImage = imageUrl;
        primaryThumbnail.dataset.mobileProductImageAlt = alt || primaryThumbnail.dataset.mobileProductImageAlt;
        const thumbnailImage = primaryThumbnail.querySelector('img');

        if (thumbnailImage) {
          thumbnailImage.src = imageUrl;
          thumbnailImage.removeAttribute('srcset');
          thumbnailImage.removeAttribute('sizes');
        }
      }
    };

    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-mobile-product-image]');

      if (!thumbnail) return;

      event.preventDefault();
      setMobilePrimaryImage(
        thumbnail.dataset.mobileProductImage,
        thumbnail.dataset.mobileProductImageAlt,
        false
      );

      document.querySelectorAll('[data-mobile-product-image]').forEach((item) => {
        item.classList.toggle('is-active', item === thumbnail);
      });
    });

    document.querySelectorAll('variant-selection').forEach((variantSelector) => {
      variantSelector.addEventListener('variant-change', (event) => {
        const variant = event.detail && event.detail.variant;
        const variantImage = variant && (variant.featured_image || (variant.featured_media && variant.featured_media.preview_image));

        if (!variantImage || !variantImage.src) return;

        setMobilePrimaryImage(variantImage.src, variantImage.alt, true);
        document.querySelectorAll('[data-mobile-product-image]').forEach((item, index) => {
          item.classList.toggle('is-active', index === 0);
        });
      });
    });
  }

  document.addEventListener('click', (event) => {
    const actionButton = event.target.closest('[data-mobile-product-action]');

    if (!actionButton) return;

    event.preventDefault();

    const { mobileProductAction: action } = actionButton.dataset;

    if (action === 'quantity') {
      const quantity = getProductControl('quantity-selector');

      if (quantity) {
        quantity.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = quantity.querySelector('input');
        if (input) input.focus({ preventScroll: true });
      }
      return;
    }

    if (action === 'add') {
      addCurrentProductToCart().catch(() => {
        const atcControl = getProductControl('[data-product-atc]');
        if (atcControl) atcControl.click();
      });
      return;
    }

    const control = getProductControl('[data-product-checkout]');

    if (control) {
      control.click();
      return;
    }

    if (action === 'checkout') openCart();
  });
})();
